"use client";

import { useRouter } from "@/i18n/navigation";
import { useAuth } from "@/auth/hooks/clerk-hooks";
import { Shield } from "lucide-react";
import { CustomButton } from "@/components/ui/custom-button";

export const AdminButton = () => {
	const router = useRouter();
	const { orgRole } = useAuth();
	const admin_entry = orgRole === "org:superadmin" ? "/superadmin" : "/admin";

	return (
		<CustomButton
			type="button"
			variant="outline"
			size="sm"
			className="whitespace-nowrap"
			onClick={() => router.push(admin_entry)}
		>
			<Shield className="mr-2 size-4" />
			<span>Admin</span>
		</CustomButton>
	);
};
